<app-navigation-bar />
<div class="pt-[163px] max-[1350px]:pt-[81.3px] max-[1350px]:pb-[54px]">
  <router-outlet />
</div>
